<div class="profile-dropdown cursor-default">
  <div class="profile-section">
    <img src="assets/images/user_logo.png" alt="" srcset=""
    class="profile-img" />
    <ul class="profile-setting" title="My Team">
      
      <li>{{ user.team}}</li>
    </ul>
  </div>
  <ul class="profile-data">
    <li class="cursor-default" title="My Username">
      <i class="fn-global-user"></i>
      {{ user.name}}
    </li>
    <li class="cursor-default" title="My EmailId">
      <i class="fn-global-mail"></i>
      {{ user.emailId}}
    </li>
    <li class="cursor-default" title="Release Version">
      <i class="fn-global-flag"></i>
      {{ user.releaseVersion}}
    </li>
    <li (click)="serverDetails()">
      <i class="fn-global-site"></i>
      Server Health
    </li>
    <li (click)="logout()">
      <i class="fn-global-logout red"></i>
      Logout
    </li>
  </ul>
</div>
